import { FC } from "react";
import { ExpandableAlert, Stack } from "shared/components/Spor";
import { ErrorResult } from "shared/utils/useParseResult";

type ParseResultDisplayerProps = {
  errors: ErrorResult[] | undefined;
};

export const ParseResultDisplayer: FC<ParseResultDisplayerProps> = ({
  errors,
}) => {
  if (!errors || errors.length === 0) return null;
  return (
    <Stack>
      <ExpandableAlert
        title={`Noe gikk galt med lastingen av ${errors.length} hendelser`}
        variant="important"
      >
        <Stack>
          {errors.map((error, i) => (
            <li
              // eslint-disable-next-line react/no-array-index-key -- We dont have anything else to go by
              key={i}
            >
              {error.join(", ")}
            </li>
          ))}
        </Stack>
      </ExpandableAlert>
    </Stack>
  );
};
